import { WorkflowController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Renders a workflow buttons in the toolbar for assign, issue, close.
 * @example
 * ```html
 * <salaxy-workflow-buttons api-ctrl="$ctrl" disabled="!ok"></salaxy-workflow-buttons>
 * ```
 */
export class WorkflowButtons extends ComponentBase {

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = {
      /** Expression for the api controller . */
      apiCtrl: "<",
      /** Optional binding for enabling/disabling the controls */
      disabled: "<",
      /** on-change event */
      onChange: "&",
      /** Option to show/hide workflow assign control. Default is true */
      showWorkflowAssign: "<"
    };

    /** Uses the WorkflowController */
    public controller = WorkflowController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/workflow/WorkflowButtons.html";
}
